/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Tab_DeepmatchInputs */

const en_landing_tab_deepmatch = /** @type {(inputs: Landing_Tab_DeepmatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const de_landing_tab_deepmatch = /** @type {(inputs: Landing_Tab_DeepmatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const fr_landing_tab_deepmatch = /** @type {(inputs: Landing_Tab_DeepmatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const es_landing_tab_deepmatch = /** @type {(inputs: Landing_Tab_DeepmatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const it_landing_tab_deepmatch = /** @type {(inputs: Landing_Tab_DeepmatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const nl_landing_tab_deepmatch = /** @type {(inputs: Landing_Tab_DeepmatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const pl_landing_tab_deepmatch = /** @type {(inputs: Landing_Tab_DeepmatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const fi_landing_tab_deepmatch = /** @type {(inputs: Landing_Tab_DeepmatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const da_landing_tab_deepmatch = /** @type {(inputs: Landing_Tab_DeepmatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

const sv_landing_tab_deepmatch = /** @type {(inputs: Landing_Tab_DeepmatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep Match`)
};

/**
* | output |
* | --- |
* | "Deep Match" |
*
* @param {Landing_Tab_DeepmatchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_tab_deepmatch = /** @type {((inputs?: Landing_Tab_DeepmatchInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Tab_DeepmatchInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_tab_deepmatch(inputs)
	if (locale === "fr") return fr_landing_tab_deepmatch(inputs)
	if (locale === "es") return es_landing_tab_deepmatch(inputs)
	if (locale === "it") return it_landing_tab_deepmatch(inputs)
	if (locale === "nl") return nl_landing_tab_deepmatch(inputs)
	if (locale === "pl") return pl_landing_tab_deepmatch(inputs)
	if (locale === "fi") return fi_landing_tab_deepmatch(inputs)
	if (locale === "da") return da_landing_tab_deepmatch(inputs)
	if (locale === "sv") return sv_landing_tab_deepmatch(inputs)
	return en_landing_tab_deepmatch(inputs)
});